import type { BlockDetails } from 'modules/campaign/block/types';
import type { PlanResponse } from '../types';

export function updateBriefSettings(block: BlockDetails, response: PlanResponse): BlockDetails {
  const updated = {
    ...block,
    budget_scope: response.settings.budget_scope,
    budget_fee_affinity: response.settings.budget_fee_affinity,
  };

  if (response.plan_strategy === 'RTB') {
    return { ...updated, target_group_size: response.settings.target_group_size };
  }

  if (updated.type === 'RADIO' && response.plan_strategy === 'RADIO') {
    return { ...updated, radio_clips: response.settings.radio_clips };
  }

  return updated;
}
